import { render, staticRenderFns } from "./Neuter.vue?vue&type=template&id=81415e58&scoped=true&"
import script from "./Neuter.vue?vue&type=script&lang=js&"
export * from "./Neuter.vue?vue&type=script&lang=js&"
import style0 from "./Neuter.vue?vue&type=style&index=0&id=81415e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81415e58",
  null
  
)

export default component.exports